import { useLocation } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { isAppMainFlushPathname } from "../../appRoutes";
import { cn } from "~/lib/utils";

export function AppMain(props: { children: ReactNode; className?: string }) {
  const pathname = useLocation({ select: (loc) => loc.pathname });
  const flush = isAppMainFlushPathname(pathname);

  return (
    <main
      data-slot="app-main"
      data-variant={flush ? "flush" : "document"}
      className={cn(
        "min-h-0 min-w-0 flex-1 bg-background",
        flush
          ? "overflow-hidden p-0"
          : "overflow-y-auto overscroll-y-contain px-3 py-3 sm:px-4 sm:py-4 lg:px-6 lg:py-6",
        props.className,
      )}
    >
      {flush ? (
        <div className="flex h-full min-h-0 min-w-0 flex-col overflow-hidden">{props.children}</div>
      ) : (
        props.children
      )}
    </main>
  );
}
